<template>
  <b-card :class="'border-left-' + variant" style="height: 300px;">
    <div class="row no-gutters align-items-center">
      <div class="col mr-2">
        <slot>
          <div :class="'font-weight-bold text-uppercase mb-1 text-' + variant">
            <b-badge pill :variant="variant">{{ badge }}</b-badge>
          </div>
          <div class="h1 mb-0 font-weight-bold text-gray-800">
            {{ name }}
          </div>

          <div v-if="date" class="h6 mb-0 font-weight-bold text-gray-800">
            Momento da Solicitação: {{date}}
          </div>
          <div v-if="recipients" class="h6 mb-0 font-weight-bold text-gray-800">
            Recipientes: {{ recipients }}
          </div>
          <div v-if="device" class="h6 mb-0 font-weight-bold text-gray-800">
            Aparelho: {{device}}
          </div>
          <div v-if="sector" class="h6 mb-0 font-weight-bold text-gray-800">
            Setor: {{ sector }}
          </div>
          <div v-if="integrationDestination" class="h6 mb-0 font-weight-bold text-gray-800">
            Integração de Destino: {{ integrationDestination }}
          </div>
          <div class="mt-3">
            <b-button href="#" variant="primary" @click="realizeQueue(device, recipients)">Finalizar Atendimento</b-button>
          </div>
        </slot>
      </div>      
    </div>
  </b-card>
</template>

<script>
export default {
  name: "MainQueueCard",
  props: {
    variant: {
      type: String,
      default: 'primary'
    },
    badge:{
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },    
    date: {
      type: String,
      default: null
    },
    recipients: {
      type: String,
      default: null
    },
    device: {
      type: String,
      default: null
    },
    sector: {
      type: String,
      default: null
    },
    integrationDestination: {
      type: String,
      default: null
    }
  },
  computed: {
    smallScreen() {
      return window.innerWidth <= 680
    }    
  },
  methods: {
    realizeQueue(device, recipients) {
      this.$emit('realizeQueue', device, recipients)
    }
  }
}
</script>

<style scoped>

</style>
